module.exports = __webpack_public_path__ + "img/sms-logo.9c6e8c9a.png";